var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotFound(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 32,
    viewBox: "0 0 37 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.166748 31.9997L18.5001 0.333008L36.8334 31.9997H0.166748ZM4.50008 29.4997H32.5001L18.5001 5.33301L4.50008 29.4997ZM18.6667 27.1247C19.0279 27.1247 19.3265 27.0066 19.5626 26.7705C19.7987 26.5344 19.9167 26.2358 19.9167 25.8747C19.9167 25.5136 19.7987 25.215 19.5626 24.9788C19.3265 24.7427 19.0279 24.6247 18.6667 24.6247C18.3056 24.6247 18.007 24.7427 17.7709 24.9788C17.5348 25.215 17.4167 25.5136 17.4167 25.8747C17.4167 26.2358 17.5348 26.5344 17.7709 26.7705C18.007 27.0066 18.3056 27.1247 18.6667 27.1247ZM17.4167 22.4997H19.9167V13.1663H17.4167V22.4997Z",
    fill: "#CCCCCC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotFound);
export default __webpack_public_path__ + "static/media/not-found.7bb0ab2c2564b89ba1a9b977ee4585af.svg";
export { ForwardRef as ReactComponent };